import '@/bootstrap';
import { createApp } from 'vue';
import Alpine from 'alpinejs';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import App from '@/App.vue';

import router from '@/router';

window.Alpine = Alpine;
Alpine.start();

const app = createApp(App);

app.use(ElementPlus);
app.use(router);
app.mount('#app');
